var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('advertisementModal',{ref:"advertisementModal",on:{"countEnd":_vm.advertiseEnd}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }